
import { Button } from 'element-ui';
import ConfirmedView from '@/pages/cart/thanks/components/ConfirmedView.vue';
import DeclineView from '@/pages/cart/thanks/components/DeclineView.vue';
import cartMixin from '@/mixins/cartMixin';
import PageNotFound from '@/layouts/components/PageNotFound.vue';
import { getProductPrice, getVariantSelected } from '@/utils/product.js';

export default {
  layout: 'MainLayout',
  name: 'CartPage',
  // middleware: "auth",
  mixins: [cartMixin],
  data() {
    return {
      params: this.$route.query,
      userGuest: null,
    };
  },
  computed: {
    // userGuest() {
    //   let user = this.$store.state.user.guest.guestUser;
    //   return user;
    // },

    userConnected() {
      return this.$auth?.user || this.userGuest;
    },
    canDisplayThanksPage() {
      return Boolean(this.userConnected || this.isExpressCheckoutReturn);
    },
    confirmedUser() {
      const user = this.userConnected;

      // Helper: detect wallet test placeholder names
      const isPlaceholder = (name) => {
        if (!name) return true;
        const n = name.trim().toLowerCase();
        return ['card', 'express', 'test', 'browser', 'google', 'apple', 'client'].includes(n);
      };

      // Try the connected user's Customer firstname
      const customerFirstname = user?.Customer?.Firstname;
      if (customerFirstname && !isPlaceholder(customerFirstname)) {
        return user;
      }

      // Fallback: checkout store guestInfo
      const guestFirstname = this.$store.state.checkout?.guestInfo?.firstname;
      if (guestFirstname && !isPlaceholder(guestFirstname)) {
        return {
          ...(user || {}),
          Customer: {
            ...(user?.Customer || {}),
            Firstname: guestFirstname,
          },
        };
      }

      // Fallback: checkout shipping address
      const shippingFirstname = this.$store.state.checkout?.shippingAddress?.Firstname;
      if (shippingFirstname && !isPlaceholder(shippingFirstname)) {
        return {
          ...(user || {}),
          Customer: {
            ...(user?.Customer || {}),
            Firstname: shippingFirstname,
          },
        };
      }

      // Last resort
      return {
        ...(user || {}),
        Customer: {
          ...(user?.Customer || {}),
          Firstname: this.$store.state.checkout?.guestInfo?.firstname || '',
        },
      };
    },
    isExpressCheckoutReturn() {
      return this.$route.query.payment_source === 'expresscheckout';
    },
    isExpressCheckoutSuccess() {
      const status = this.$route.query.redirect_status || this.$route.query.express_status;
      if (status) return status === 'succeeded';

      return Boolean(
        this.$route.query.payment_intent &&
          this.$route.query.payment_intent_client_secret
      );
    },
    showConfirmed() {
      if (this.$route.params.state !== 'accepted') return false;
      if (!this.isExpressCheckoutReturn) return true;

      return this.isExpressCheckoutSuccess;
    },
    showDecline() {
      if (this.$route.params.state === 'decline') return true;

      return (
        this.$route.params.state === 'accepted' &&
        this.isExpressCheckoutReturn &&
        !this.isExpressCheckoutSuccess
      );
    },
  },
  methods: {
    purchaseGtm() {
      const orderid = this.$route.query.orderid;
      this.$gtm.push({
        event: 'purchase',
        ecommerce: {
          currency: this.$localisation.appCurrency.CurrencyIsoCode,
          value: this.cart?.Total?.ToPay?.TaxIncl,
          transaction_id: orderid,
          shipping: this.cart?.Total?.Shipping?.TaxIncl || 0,
          coupon: this.cart?.Total?.Discount?.TaxIncl || 0,
          items: this.cart.Products?.map((product) => ({
            item_id: product.IdProduct,
            quantity: product.Quantity,
            price: getProductPrice(product),
            item_name: product.Description.Title,
            item_brand: product?.Brand?.Name || 'Jean Marc Philippe',
            item_variant: getVariantSelected(product),
          })),
        },
      });
    },
    async resetExpressGuestCart() {
      if (!this.isExpressCheckoutReturn || this.$auth?.loggedIn) return;

      const guest = this.$store.state.user.guest.guestUser;
      if (guest) {
        this.userGuest = { ...guest };
      }

      this.cartService.clearCart();

      try {
        const newCart = await this.cartService.initNewCart();
        if (newCart?.IdCart) {
          this.cartService.setIdCartToCookies(newCart.IdCart);
        }
      } catch (e) {
        // ignore: we still keep thanks page visible
      }

      if (guest) {
        this.$store.dispatch('user/guest/setGuestUser', {
          user: null,
          cookies: this.$cookies,
        });
      }

      try {
        await this.$store.dispatch('cart/fetchCart');
      } catch (e) {
        // ignore: empty cart state is acceptable here
      }
    },
  },
  async mounted() {
    this.$store.commit('shared/wind/setIsLoading', false);
    // if (!this.userConnected) {
    //   this.$router.push({
    //     path: this.localePath('/'),
    //   });
    // }

    const orderid = this.$route.query.orderid;
    const cartid = this.$route.query.cartid;
    if (this.showConfirmed) {
      this.purchaseGtm();
    }

    if (this.showConfirmed && String(cartid) === String(this.cartService.idCart)) {
      await this.cartService.finishOrder(orderid, 'accepted');

      if (this.$store.state.user.guest.guestUser && !this.isExpressCheckoutReturn) {
        this.userGuest = { ...this.$store.state.user.guest.guestUser };

        this.$store.dispatch('user/guest/setGuestUser', {
          user: null,
          cookies: this.$cookies,
        });
        setTimeout(() => {
          this.cartService.clearCart();
        }, 500);
      }
    }

    if (this.showConfirmed) {
      await this.resetExpressGuestCart();
    }
  },
  components: { Button, ConfirmedView, DeclineView, PageNotFound },
};
